import { render, staticRenderFns } from "./participants.vue?vue&type=template&id=465081f2&scoped=true"
import script from "./participants.vue?vue&type=script&lang=js"
export * from "./participants.vue?vue&type=script&lang=js"
import style0 from "./participants.vue?vue&type=style&index=0&id=465081f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465081f2",
  null
  
)

export default component.exports